<template>
  <div>
    <div class="l-container">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getVersions()
      vm.getUsers()
      vm.getUser()
      vm.getOffices()
      vm.getCompanies()
    })
  },
  methods: {
    getVersions () {
      this.$store.dispatch('getVersions')
    },
    getUsers () {
      this.$store.dispatch('getUsersSelect')
    },
    getUser () {
      this.$store.dispatch('getUser')
    },
    getOffices () {
      this.$store.dispatch('getOffices')
    },
    getCompanies () {
      this.$store.dispatch('getCompanies')
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Versions.vue?991840d2